<h1 mat-dialog-title>{{((data.isNew ? 'Upload' : 'Edit') + ' resource') | translate}}</h1>
<div mat-dialog-content>

  <!-- Resource name -->
  <mat-form-field>
    <mat-label>{{ 'Name' | translate }}</mat-label>
    <input matInput [(ngModel)]="data.name">
  </mat-form-field>

  <!-- File input -->
  <mat-form-field *ngIf="data.isNew">
    <ngx-mat-file-input [(ngModel)]="data.file" [accept]="getAcceptMimeType()" (ngModelChange)="checkFile()" [placeholder]="'Choose a file' | translate"></ngx-mat-file-input>
  </mat-form-field>

  <!-- Tags -->
  <mat-form-field class="tags" appearance="fill">
    <mat-label>{{ 'Tags' | translate }}</mat-label>
    <mat-chip-list #chipList aria-label="Fruit selection">
      <mat-chip
        *ngFor="let tag of data.tags"
        [selectable]="selectable"
        [removable]="removable"
        (removed)="remove(tag)">
        {{tag}}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
      <input [placeholder]="'Add new tag...' | translate"
             [matChipInputFor]="chipList"
             [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
             [matChipInputAddOnBlur]="addOnBlur"
             (matChipInputTokenEnd)="add($event)">
    </mat-chip-list>
  </mat-form-field>

</div>
<div mat-dialog-actions class="actions">
  <button mat-stroked-button (click)="onNoClick()">{{ 'Cancel' | translate }}</button>
  <div>
    <button mat-flat-button color="primary" [mat-dialog-close]="data" cdkFocusInitial>{{ 'Save' | translate }}</button>
  </div>
</div>
